// File Metadata:
// Filename: NewShipmentFormType.js
// Version: 1.00
// Created: 2022-10-21 21:08:36
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React, { Component } from 'react'
import {
	FormControl,
	FormControlLabel,
	FormLabel,
	Radio,
	RadioGroup,
	Button,
	Card,
	CardHeader,
	CardContent
} from '@mui/material'
import { TYPES } from '../../../config/constants'

export class NewShipmentFormType extends Component {
	continue = e => {
		e.preventDefault()
		this.props.nextStep()
	}

	logTypeOptions = TYPES.tasklog.map(type => {
		return <FormControlLabel value={type.taskId} control={<Radio size='medium' />} label={type.text} />
	})

	render() {
		const { values, handleChange } = this.props
		return (
			<Card sx={{ width: 345, minWidth: 200, boxShadow: 2, margin: 2 }}>
				<CardHeader title='Step 1: Shipment Log Type' subheader='' />
				<CardContent>
					<FormControl margin='normal' fullWidth variant='filled'>
						<FormLabel id='shipmenttype'>Select your log type</FormLabel>
						<RadioGroup
							id='shipmenttype'
							aria-labelledby='demo-controlled-radio-buttons-group'
							name='shipmenttype'
							value={values.type}
							onChange={handleChange('type')}
						>
							{this.logTypeOptions}
						</RadioGroup>
					</FormControl>
					<Button onClick={this.continue} fullWidth variant='contained'>
						Continue
					</Button>
				</CardContent>
			</Card>
		)
	}
}

export default NewShipmentFormType
